export enum QueryKey {
	ConsolidatedFeedbackIndex = 'consolidated-feedback',
	FeedbackIndex = 'feedback-index',
	FeedbackByIds = 'feedback-by-ids',
	UnrequestedFeedbackDrafts = 'unrequested-feedback-drafts',
}
